module.exports = __webpack_public_path__ + "img/badge-most-proposals-bronze.d4eeadb4.png";